import { React, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import StackedChart from "../../components/StackedChart";
import { DataGrid } from "@mui/x-data-grid";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import faker from "faker";
import {
  DashboardIcon,
  User,
  Role,
  Marketing,
  Payment,
  Financing,
  Appointment,
  Ezpay,
  Ezplan,
  Administrator,
  Content,
  Notification,
  TotalMonth,
  TotalPlans,
  TotalFinance,
  TotalCare,
  TotalPatients,
  Logout,
  SearchIcon,
  DashboardNotification,
  Profilearrow,
  Settings,
  LogoutProfile,
  MenuDots
} from "../../constants/svg";
import { Assets } from "../../constants/images";
import LineGraph from "../../components/LineGraph";
import CareGraph from "../../components/CareGraph";
import TotalPlansGraph from "../../components/TotalPlansGraph";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
// import SearchIcon from "@material-ui/icons/Search";
import Box from "@mui/material/Box";
import Statistics from "../../components/Statistics";
import DashboardSidebar from "../../components/DashboardSidebar";
import ProfileBox from "../../components/ProfileBox";
import { Link, NavLink } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import ResponsiveNavbar from "../../components/ResponsiveNavbar";
import ThemeModal from "../../components/ThemeModal";
import { Button } from "react-bootstrap";
import TopBar from "../../components/TopBar";
import Breadcrumb from "react-bootstrap/Breadcrumb";


const EzPayRecords = () => {

    
  const columns = [
    {
      field: "UserId",
      headerName: "User ID",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "clientname",
      headerName: "Client Name",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "treatment",
      headerName: "Plan Name",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "email",
      headerName: "Email Address",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "invoicedate",
      headerName: "Invoice Date",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "invoiceno",
      headerName: "Invoice No",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "transactionid",
      headerName: "Transaction ID",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "duedate",
      headerName: "Due Date",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
  ];

  const rows = [
    {
      id: 1,
      UserId: "01",
      clientname: "Paul Doe",
      treatment: "Dental",
      email: "PaulDoe@gmai.com",
      invoicedate: "abc",
      invoiceno: "abc",
      transactionid: "3",
      duedate: "3",
    },
    {
      id: 2,
      UserId: "02",
      clientname: "Paul Doe",
      treatment: "Dental",
      email: "PaulDoe@gmai.com",
      invoicedate: "abc",
      invoiceno: "abc",
      transactionid: "3",
      duedate: "3",
    },

    {
      id: 3,
      UserId: "03",
      clientname: "Paul Doe",
      treatment: "Dental",
      email: "PaulDoe@gmai.com",
      invoicedate: "abc",
      invoiceno: "abc",
      transactionid: "3",
      duedate: "3",
    },
    {
      id: 4,
      UserId: "04",
      clientname: "Paul Doe",
      treatment: "Dental",
      email: "PaulDoe@gmai.com",
      invoicedate: "abc",
      invoiceno: "abc",
      transactionid: "3",
      duedate: "3",
    },
    {
      id: 5,
      UserId: "05",
      clientname: "Paul Doe",
      treatment: "Dental",
      email: "PaulDoe@gmai.com",
      invoicedate: "abc",
      invoiceno: "abc",
      transactionid: "3",
      duedate: "3",
    },
    {
      id: 6,
      UserId: "06",
      clientname: "Paul Doe",
      treatment: "Dental",
      email: "PaulDoe@gmai.com",
      invoicedate: "abc",
      invoiceno: "abc",
      transactionid: "3",
      duedate: "3",
    },
    {
      id: 7,
      UserId: "07",
      clientname: "Paul Doe",
      treatment: "Dental",
      email: "PaulDoe@gmai.com",
      invoicedate: "abc",
      invoiceno: "abc",
      transactionid: "3",
      duedate: "3",
    },
    {
      id: 8,
      UserId: "08",
      clientname: "Paul Doe",
      treatment: "Dental",
      email: "PaulDoe@gmai.com",
      invoicedate: "abc",
      invoiceno: "abc",
      transactionid: "3",
      duedate: "3",
    },
    {
      id: 9,
      UserId: "09",
      clientname: "Paul Doe",
      treatment: "Dental",
      email: "PaulDoe@gmai.com",
      invoicedate: "abc",
      invoiceno: "abc",
      transactionid: "3",
      duedate: "3",
    },
  ];

  return (
        <div className="user-management">
      <Row>
        <Col md={12}>
          <div className='breadcrumbs'>
          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Dashboard</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              <NavLink to="/">Ez Pay Dashboard</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              <NavLink to="/">Ez Pay Records</NavLink>
            </Breadcrumb.Item>
          </Breadcrumb>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <h2>Ez Pay Records</h2>
        </Col>
        <Col md={6}>
          <div className="d-flex justify-content-end d-none">
            <div>
              <Button className="filter-btn">Filter</Button>
            </div>
            <div>
              <Button className="add-new-btn ms-3">+ Add New</Button>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className="table-container">
            <div style={{ height: 650, width: "100%" }}>
              <DataGrid
                className="datagrid-table"
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[7]}
                checkboxSelection
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default EzPayRecords